<template>
  <div class="vote-progress">
    <van-progress :percentage="percentage" :show-pivot="false" color="var(--progress-color)"/>
    <div class="progress-text-wrapper">
      <span>{{ count }} 票</span>
      <span>{{ percentage }}%</span>
    </div>
  </div>
</template>

<script>
export default {
  name: 'VoteProgress',
  props: {
    vote: {
      type: Object,
      default: () => ({})
    },
    label: {
      type: String,
      default: ''
    },
    checked: {
      type: Boolean,
      default: false
    },
    selected:{
      type: Boolean,
      default: false
    }
  },
  computed: {
    percentage() {
      if(this.total===0) return 0
      return Number((this.count / this.total * 100).toFixed(0))
    },
    total() {
      let res = this.vote.totalNum
      if (this.selected) res += 1
      return res
    },
    count() {
      let current = this.vote.oidCountMap[this.label] || 0
      if (this.checked) {
        current += 1
      }
      return current
    }
  }
}
</script>

<style scoped lang="scss">
.vote-progress {
  @apply text-medium;
  padding: 4px 12px 4px 36px;

  .progress-text-wrapper {
    margin-top: 8px;
    display: flex;
    justify-content: space-between;
    color: rgba(0, 0, 0, .45);
  }
}
</style>